import React from 'react';
import PropTypes from 'prop-types';
import { Map } from 'immutable';

import Button from '@Components/Button';
import GroupOfMoreCheckbox from './GroupOfMoreCheckbox';
import GroupOfMoreCheckRadio from './GroupOfMoreCheckRadio';
import GroupOfMoreInput from './GroupOfMoreInput';

import './GroupOfMore.custom.scss';

const mapComponents = {
  checkbox: GroupOfMoreCheckbox,
  check_radio: GroupOfMoreCheckRadio,
  input: GroupOfMoreInput,
};

export default function GroupOfMore(props) {
  const { group, groupId, showMore, toggelMore } = props;
  const optionsIds = group.get('optionsIds');
  const options = group.get('options');

  return (
    <section className="group-of-more">
      {!showMore &&
        optionsIds.map((id) => {
          const option = options.get(id);
          const type = option.get('type');
          const Component = mapComponents[type];

          if (!Component) {
            Logger.error(`Unknown option's type for GroupOfMore component :${option.toJS()}`);
            return null;
          }

          return <Component key={id} {...props} groupId={groupId} optionId={id} option={option} />;
        })}
      <Button
        onClick={toggelMore}
        buttonConfig={{
          type: 'link',
          size: 'sm',
          label: showMore ? 'More Options' : 'Fewer Options',
          className: 'group-of-more__toggle-button',
          e2eName: showMore ? 'more-options' : 'fewer-options',
        }}
        iconConfig={{ name: showMore ? 'plus' : 'minus', size: 'sm', position: 'before' }}
      />
    </section>
  );
}

GroupOfMore.propTypes = {
  group: PropTypes.instanceOf(Map).isRequired,
  groupId: PropTypes.string.isRequired,
  showMore: PropTypes.bool.isRequired,
  toggelMore: PropTypes.func.isRequired,
};
